module.exports = __webpack_public_path__ + "static/img/050403.d089afbb.png";